import { Component, OnInit } from '@angular/core';
import { BrowserStorageHelper } from '@core/helpers';

@Component({
    selector: 'app-account-clear-cookies',
    templateUrl: './account-clear-cookies.component.html',
    styleUrls: ['./account-clear-cookies.component.scss'],
    standalone: true,
})
export class AccountClearCookiesComponent implements OnInit {
    ngOnInit(): void {
        BrowserStorageHelper.killSession();
    }
}
